import React from 'react';

const DifficultyMenu=() => {
    return (
        <div>
            <h1>
                Experience:
            </h1>
            <select id="experience">
                <option>Any</option>
                <option>Beginner</option>
                <option>Intermediate</option>
                <option>Advanced</option>
            </select>
        </div>

    )
}

export default DifficultyMenu